import { Box, Button, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiurl } from "../services/authServices";

function Login() {
  const navigate = useNavigate();
  const [fields, setFields] = useState({
    user_id: "",
    password: "",
  });
  // console.log("fields", fields);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((prevfield) => ({
      ...prevfield,
      [name]: value,
    }));
  };

  // const handleReset = () => {
  //   setFields({
  //     user_id: "",
  //     password: "",
  //   });
  // };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(apiurl + "/api/getpost", {
        // screenCode: "1723617211",
        // screenCode: "1727969685",
        screenCode: fields.user_id,
        machineCode: fields.password,
      });
      if (response.data.message === "Data Not Available") {
        alert("User ID not correct Something Went wrong");
      } else {
        console.log("RES=>>", response.data.message);
        // navigate("/dashboard");
        const dataToSend = {
          data: response.data.data,
          id: fields.user_id, // Replace this with your second piece of data
          pass: fields.password, // Replace this with your second piece of data
        };
        navigate("/dashboardMap", { state: dataToSend });
      }
    } catch (error) {
      console.error("err=>>", error);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor="#F2F6F8"
    >
      <Typography
        variant="h5"
        component="h5"
        sx={{ textAlign: "center", fontFamily: "cursive", fontWeight: "bold" }}
      >
        WELCOME USER
      </Typography>

      <Box display="flex" flexDirection="column" alignItems="center">
        <TextField
          type="text"
          placeholder="User Id"
          name="user_id"
          value={fields.user_id}
          onChange={handleChange}
          variant="outlined"
          sx={{
            margin: "10px",
            width: {
              xs: "90%", // Mobile
              sm: "300px", // Small devices and up
            },
          }}
        />

        <TextField
          type="password"
          placeholder="Password"
          name="password"
          value={fields.password}
          onChange={handleChange}
          variant="outlined"
          sx={{
            margin: "10px",
            width: {
              xs: "90%", // Mobile
              sm: "300px", // Small devices and up
            },
          }}
        />
      </Box>

      <Box display="flex" justifyContent="center" width="15%">
        {/* <Button
          onClick={handleReset}
          variant="contained"
          color="info"
          sx={{ margin: "20px", fontFamily: "cursive" }}
        >
          Reset
        </Button> */}

        <Button
          // onClick={() => navigate("/dashboard")}
          onClick={handleSubmit}
          variant="contained"
          color="success"
          sx={{
            margin: "20px",
            fontFamily: "cursive",
            width: {
              xs: "90%", // Mobile
              sm: "300px", // Small devices and up
            },
          }}
        >
          Login
        </Button>
      </Box>
    </Box>
  );
}

export default Login;
